/**
 * GenerateButton.
 *
 * Clicking Generate Ad snapshots the current brief into the generation queue.
 * The button is disabled only while that queue POST is in flight; an existing
 * streaming run should not block the user from preparing and queueing the next
 * brief.
 */
import { Button } from '@mantine/core';
import { useCreateRun } from '../../hooks/use-create-run';
import { useBriefFormStore } from '../../state/brief-form-store';
import { useRunStreamStore } from '../../state/run-stream-store';

export function GenerateButton() {
  const { submitting, submit } = useCreateRun();
  const setRunId = useRunStreamStore((s) => s.setRunId);
  const resetForm = useBriefFormStore((s) => s.reset);
  const saveLastSubmittedBrief = useBriefFormStore((s) => s.saveLastSubmittedBrief);
  const mode = useBriefFormStore((s) => s.mode);
  const label =
    mode === 'scratch_premise_set'
      ? 'Generate premise set'
      : mode === 'fb_ad_to_advertorial' || mode === 'competitor_advertorial_to_advertorial'
        ? 'Generate advertorial'
        : 'Generate Ad';

  async function handleClick() {
    if (submitting) return;

    const result = await submit();
    if (!result.ok) return;

    saveLastSubmittedBrief();
    if (result.runId) {
      setRunId(result.runId);
    }
    resetForm({ preserveLastSubmittedBrief: true });
  }

  return (
    <Button
      fullWidth
      color="accent"
      variant="filled"
      disabled={submitting}
      onClick={handleClick}
      mt="md"
      data-testid="generate-btn"
    >
      {submitting ? 'Generating...' : label}
    </Button>
  );
}
